import { api } from "@/redux/api";

import { ReviewStatus, ReviewStatusSchema } from "@/schemas/review-status";

import {
	CopywritingFramework,
	CopywritingFrameworkListResponse,
	CopywritingFrameworkListResponseSchema,
	CopywritingFrameworkSchema,
	CreateCopywritingFramework,
	UpdateCopywritingFramework,
} from "../../pages/Company/schema/copywritingFramework";

export const copywritingFrameworkApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCopywritingFrameworks: builder.query<CopywritingFrameworkListResponse, void>({
			query: () => ({
				url: "copywriting-framework",
				responseSchema: CopywritingFrameworkListResponseSchema,
			}),
			providesTags: ["CopywritingFramework"],
		}),

		getCopywritingFrameworkReviewStatus: builder.query<ReviewStatus, void>({
			query: () => ({
				url: "copywriting-framework/review-status",
				responseSchema: ReviewStatusSchema,
			}),
			providesTags: ["CopywritingReviewStatus"],
		}),

		markCopywritingFrameworkReviewed: builder.mutation<ReviewStatus, void>({
			query: () => ({
				url: "copywriting-framework/mark-reviewed",
				method: "POST",
				responseSchema: ReviewStatusSchema,
			}),
			invalidatesTags: ["CopywritingReviewStatus"],
		}),

		getCopywritingFramework: builder.query<CopywritingFramework, number>({
			query: (id) => ({
				url: `copywriting-framework/${id}`,
				responseSchema: CopywritingFrameworkSchema,
			}),
			providesTags: ["CopywritingFramework"],
		}),

		createCopywritingFramework: builder.mutation<CopywritingFramework, CreateCopywritingFramework>({
			query: (body) => ({
				url: "copywriting-framework",
				method: "POST",
				body,
				responseSchema: CopywritingFrameworkSchema,
			}),
			invalidatesTags: ["CopywritingFramework"],
		}),

		updateCopywritingFramework: builder.mutation<
			CopywritingFramework,
			{ id: number } & UpdateCopywritingFramework
		>({
			query: ({ id, ...body }) => ({
				url: `copywriting-framework/${id}`,
				method: "PATCH",
				body,
				responseSchema: CopywritingFrameworkSchema,
			}),
			invalidatesTags: ["CopywritingFramework"],
		}),

		toggleCopywritingFramework: builder.mutation<CopywritingFramework, number>({
			query: (id) => ({
				url: `copywriting-framework/${id}/toggle`,
				method: "PATCH",
				responseSchema: CopywritingFrameworkSchema,
			}),
			invalidatesTags: ["CopywritingFramework"],
		}),

		deleteCopywritingFramework: builder.mutation<void, number>({
			query: (id) => ({
				url: `copywriting-framework/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["CopywritingFramework"],
		}),
	}),
});

export const {
	useGetCopywritingFrameworksQuery,
	useGetCopywritingFrameworkQuery,
	useGetCopywritingFrameworkReviewStatusQuery,
	useMarkCopywritingFrameworkReviewedMutation,
	useCreateCopywritingFrameworkMutation,
	useUpdateCopywritingFrameworkMutation,
	useToggleCopywritingFrameworkMutation,
	useDeleteCopywritingFrameworkMutation,
} = copywritingFrameworkApi;
